module.exports = __webpack_public_path__ + "img/1483765537.94f1c108.jpg";